import { render, staticRenderFns } from "./AuthViaMerchantSettings.vue?vue&type=template&id=0ab338cd&scoped=true&"
import script from "./AuthViaMerchantSettings.vue?vue&type=script&lang=js&"
export * from "./AuthViaMerchantSettings.vue?vue&type=script&lang=js&"
import style0 from "./AuthViaMerchantSettings.vue?vue&type=style&index=0&id=0ab338cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab338cd",
  null
  
)

export default component.exports